import "../../../chunk-D57E6H3M.mjs";

// src/components/composite/Conversations/composer-draft.ts
function createComposerDraft() {
  return { text: "", attachments: [], busy: null, uploading: 0, sent: false, attachmentError: null };
}
export {
  createComposerDraft
};
//# sourceMappingURL=composer-draft.mjs.map